module.exports = __webpack_public_path__ + "static/media/Nalwaya ji_page-0001.97bfa4fb.jpg";